module.exports = __webpack_public_path__ + "static/media/01B.b6058bb3.png";